import React from "react";
import { cn } from "../../../lib/utils";
import { SelectionIndicator } from "./SelectionIndicator";
import { OptionInfo } from "./OptionInfo";
import { OptionPrice } from "./OptionPrice";

interface OptionItemProps {
  option: any;
  section: any;
  isSelected: boolean;
  canSelect: boolean;
  onToggle: (value: boolean) => void;
}

export const OptionItem: React.FC<OptionItemProps> = ({
  option,
  section,
  isSelected,
  canSelect,
  onToggle,
}) => {
  return (
    <div
      className={cn(
        "flex items-center p-6 transition-all duration-300 border group hover:shadow-sm",
        isSelected
          ? "bg-black border-black text-white shadow-sm"
          : "bg-white border-gray-200 text-black hover:border-black/20",
        !canSelect && "opacity-50 relative cursor-pointer"
      )}
      title={
        !canSelect
          ? "Selecting this option will replace incompatible selections"
          : ""
      }
    >
      <div
        className="flex items-center justify-center mr-4 cursor-pointer"
        onClick={() => onToggle(!isSelected)}
      >
        <SelectionIndicator
          isSelected={isSelected}
          isMultiple={section?.multiple}
        />
      </div>
      <div className="grow">
        <div className="flex items-center">
          {option?.metadata?.uiColor && (
            <div
              className="w-4 h-4 rounded-full mr-3 border border-gray-200"
              style={{
                backgroundColor: option.metadata.uiColor,
              }}
            />
          )}
          <p
            className="text-base cursor-pointer"
            style={{ fontWeight: "300" }}
            onClick={() => onToggle(!isSelected)}
          >
            {option.label}
          </p>
          <div className="ml-3">
            <OptionInfo option={option} />
          </div>
          {!canSelect && (
            <span
              className={cn(
                "ml-3 font-medium text-xs",
                isSelected ? "text-gray-300" : "text-gray-500"
              )}
            >
              (Replace required)
            </span>
          )}
        </div>
        {option?.metadata?.uiDescription && (
          <p
            className={cn(
              "text-sm mt-2 leading-relaxed",
              isSelected ? "text-gray-300" : "text-gray-600"
            )}
          >
            {option.metadata.uiDescription}
          </p>
        )}
      </div>
      <div className="flex items-center">
        <OptionPrice price={option.price} isSelected={isSelected} />
      </div>
    </div>
  );
};
